// extracted by mini-css-extract-plugin
export default {"loading":"spinner_loading__wUTi2"};